import { Flex, Stack, Text } from '@mantine/core';
import { IconCheck } from '@tabler/icons-react';
import { useSuspenseQuery } from '@tanstack/react-query';
import { useTranslation } from 'react-i18next';

import { InfraAddButton } from '@/module/Laboratory/infra/InfraAddButton';
import { InfraDeleteButton } from '@/module/Laboratory/infra/InfraDeleteButton';
import { getCenterReportCriteriaInfraOptions } from '@/module/ResearchCenter';

import { Content, NoContentPlaceholder } from '@/core/components';

import { Id } from '@feature/utils';

export function LabInfraList({ labId }: { labId: Id }) {
  const { t } = useTranslation();
  const { data } = useSuspenseQuery(getCenterReportCriteriaInfraOptions(labId));
  return (
    <Content type="full">
      <Stack>
        <Flex
          justify="space-between"
          align="center"
        >
          <Text fw="500">{t('labs.infraTitle')}</Text>
          <InfraAddButton labId={labId} />
        </Flex>
        {data.length === 0 && (
          <NoContentPlaceholder
            mih="100px"
            title={t('labs.noInfra')}
          />
        )}
        {data.length !== 0 &&
          data.map(infra => (
            <Flex
              justify="space-between"
              align="center"
              key={infra.id}
              role="group"
              aria-label={infra.infrastructure}
            >
              <Flex align="center">
                <IconCheck
                  size={24}
                  color="green"
                />
                <Text>{infra.infrastructure}</Text>
              </Flex>
              <InfraDeleteButton
                infraId={infra.id}
                labId={labId}
              />
            </Flex>
          ))}
      </Stack>
    </Content>
  );
}
